var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23666 5.24319L3.23668 5.24318C4.22428 4.24717 5.53524 3.75 6.85397 3.75C8.17269 3.75 9.48366 4.24717 10.4713 5.24318L10.4719 5.24376L11.4675 6.24565L11.9972 6.77872L12.5292 6.24791L13.5248 5.25451L13.5248 5.25452L13.5277 5.25167C15.5078 3.25463 18.7821 3.25467 20.7623 5.25167C22.7459 7.25219 22.7459 10.4563 20.7623 12.4568C19.2952 13.9364 17.8266 15.4177 16.3582 16.8989C14.9299 18.3396 13.5017 19.7802 12.0748 21.2191L12.0742 21.2198C12.0666 21.2275 12.0559 21.2351 12.042 21.2409C12.0279 21.2467 12.0119 21.25 11.9951 21.25C11.9782 21.25 11.9622 21.2467 11.9482 21.2409C11.9342 21.2351 11.9235 21.2275 11.916 21.2198L11.9158 21.2197L3.23723 12.4489L3.23718 12.4489C1.25521 10.4462 1.25351 7.24314 3.23666 5.24319Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
};

export default SvgHeart;